import {useState} from "react";
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

const steps = [
  {
    label: 'REGISTER',
    description: 
    `As first step please register and then confirm link sent to your email address.`,
  },
  {
    label: 'COMPLETE DATA',
    description: ` `,
  },
  {
    label: 'ORDER GENOME & MICROBIOME TEST',
    description: ` `,
  },
  {
    label: 'BLOOD & STOOL SAMPLES COLLECTION',
    description: ` `,
  },
  {
    label: 'ORDER SUBSCRIPTION PLAN',
    description: ` `,
  },
   {
      label: 'COUNSELING SESSION ONLINE',
      description: ``,
    },
    {
      label: 'ENJOY PREVENTIVE HEALTH INTELLIGENCE',
      description: ``,
      },
];


export default function OnboardingSteps() {
  
  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };
  
  
  return (

    <Box sx={{ maxWidth: 350}}>
    <Stepper activeStep={activeStep} orientation="vertical">
      {steps.map((step, index) => (
        
        <Step key={step.label} sx={{ "& .MuiStepIcon-root": {color: 'grey.C900'}, "& .MuiStepLabel-root .Mui-active": { color: "traffic.red"}, 
        "& .MuiStepLabel-root .Mui-completed": { color: "traffic.green" }, }}>

          <StepLabel
            optional={
              index === steps.length - 1 ? (
                <Typography variant="subtitle2" sx={{ color: 'common.black'}}>Congratulation !</Typography>
              ) : null
            }
          >
            <Typography variant="subtitle2" sx={{ color: 'common.black'}}>{step.label}</Typography>
          </StepLabel>

          <StepContent>
            <Typography variant="subtitle2" sx={{ color: 'common.black'}}>{step.description}</Typography>
          </StepContent>
        </Step>
      ))}
    </Stepper>
    
    {activeStep === steps.length && (
      <Paper square elevation={0} sx={{ p: 3 }}>
        <Typography>All steps completed - you are finished</Typography>
        <Button onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
          Reset
        </Button>
      </Paper>
    )}
  </Box>
);
}